import { FC, PropsWithChildren } from 'react'
import { FormLabel, Stack } from '@mui/material'

interface FilterGroupProps {
  title: string
  spacing?: number
}

/**
 * One titled group of controls in a `HeaderBar` filter pop-up, e.g. "Geography Filters" or
 * "Date, Time & Day Filters". Stack groups with `spacing={3}` between them.
 */
export const FilterGroup: FC<PropsWithChildren<FilterGroupProps>> = ({
  title,
  spacing = 2,
  children,
}) => (
  <Stack spacing={spacing} role="group" aria-label={title}>
    <FormLabel>{title}</FormLabel>
    {children}
  </Stack>
)
